export const DISPUTE_APIS = {
  dispute_history: "payments/disputes/history",
  dispute_upload_documents: "payments/upload/dispute/documents",
  dispute_confirmation: "payments/dispute/accept",
  dispute_payment: "payments/dispute/order/initiate",
  payment_status: "payments/dispute/order/status",
};

export const DISPUTE_APIS_PATHNAMES = {
  payment_status: (order_id) => `${DISPUTE_APIS.payment_status}/${order_id}`,
};
